// Regex to validate international email addresses
// Example: https://rubular.com/r/bqNZ0WT0RMSaGV
export const emailAddressRegex = /^(?=^.{6,255}$)((?=.{1,64}$)((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")))@(?=.{4,190}$)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,85})))$/;
